import { ValidationWrapper } from "@App/Components/atoms/forms/ValidationWrapper";
import {
  AutocompleteField,
  type Suggestion,
} from "@App/Components/molecules/common/autocomplete/AutocompleteField";
import { AutocompleteSemantic } from "@App/domain/autocomplete/autocompleteSemantic";
import { MapPinIcon } from "@heroicons/react/16/solid";
import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

type PlaceSearchInputProps = {
  query: string;
  setQuery: (query: string) => void;
  selectedSuggestion: Suggestion | null;
  setSelectedSuggestion: (suggestion: Suggestion | null) => void;
  suggestions: Suggestion[] | null;
  isGeoLocationAvailable: boolean;
  onGeoLocationSearch: () => void;
  isGeoLocationLoading: boolean;
  error?: string | null;
};

export const PlaceSearchInput: FunctionComponent<PlaceSearchInputProps> = ({
  query,
  setQuery,
  selectedSuggestion,
  setSelectedSuggestion,
  suggestions,
  isGeoLocationAvailable,
  onGeoLocationSearch,
  isGeoLocationLoading,
  error,
}: PlaceSearchInputProps) => {
  const { t } = useTranslation();

  return (
    <div className="mt-2 relative">
      <div className="focus-within:relative">
        <ValidationWrapper error={error}>
          <AutocompleteField
            query={query}
            setQuery={setQuery}
            selectedSuggestion={selectedSuggestion}
            setSelectedSuggestion={setSelectedSuggestion}
            suggestions={suggestions?.map((place) => ({
              id: place.id,
              name: place.name,
              icon: <MapPinIcon className="size-4" />,
            }))}
            loading={isGeoLocationLoading}
            autoComplete={AutocompleteSemantic.CITY}
            placeholder={"Ort suchen"}
          />
        </ValidationWrapper>
      </div>
      {isGeoLocationAvailable && (
        <div className="pt-3 pb-5">
          <button
            type="button"
            onClick={onGeoLocationSearch}
            className="flex shrink-0 items-center gap-x-1.5 text-sm underline text-gray-400 focus:relative"
            disabled={isGeoLocationLoading}
          >
            {t("organisms.common.placeSearchInput.geoLocation.button.label")}
          </button>
        </div>
      )}
    </div>
  );
};
